const translation = {
  daysInWeek: {
    Fri: 'शुक्रवार',
    Tue: 'मंगलवार',
    Sun: 'सूर्य',
    Wed: 'बुधवार',
    Sat: 'शनिवार',
    Mon: 'मोन',
    Thu: 'गुरुवार',
  },
  months: {
    July: 'जुलाई',
    August: 'अगस्त',
    September: 'सितंबर',
    March: 'मार्च',
    May: 'मई',
    October: 'अक्टूबर',
    April: 'अप्रैल',
    December: 'दिसंबर',
    February: 'फरवरी',
    June: 'जून',
    November: 'नवंबर',
    January: 'जनवरी',
  },
  operation: {
    now: 'अब',
    pickDate: 'तारीख़ चुनें',
    ok: 'ठीक है',
    cancel: 'रद्द करें',
  },
  title: {
    pickTime: 'समय चुनें',
  },
  defaultPlaceholder: 'एक समय चुनें...',
}

export default translation
